module.exports = __webpack_public_path__ + "img/isbar_telephone.70fdb30f.jpg";